import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  FormGroup,
  IconButton,
  Menu,
  MenuItem,
  Tab,
  Typography,
} from "@mui/material";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { MotifIcon, MotifCheckbox } from "@ey-xd/motif-react";
import { moreVerticleIcon } from "../../common/MotifIcons";
import { Stepper } from "../stepper/stepper";
import { MotifButton } from "@ey-xd/motif-react";
import { apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";
import useGetApplicationData from "../../common/redux/common/getApplicationData/useGetApplicationData";
import { useDispatch } from "react-redux";
import { getApplicationData } from "../../common/redux/common/getApplicationData/getApplicationDataSlice";
import { ConfirmDialog } from "./ConfirmDialog";

import "./AdminInsights.scss";
import logger from "../../common/utils/logger";
import SafeHtml from "../../common/SafeHtml";

export const AdminInsights = () => {
  const [value, setValue] = useState(0);
  const [isInsightEdit, setIsInsightEdit] = useState(false);
  const [changedInsights, setChangedInsights] = useState([]);
  const [submittedInsights, setSubmittedInsights] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [sector, setSector] = useState();
  const [sectorData, setSectorData] = useState([]);
  const open = Boolean(anchorEl);
  const [isLoading, setIsLoading] = useState(false);
  const [checkboxes1, setCheckboxes1] = useState({});
  const [insightsData, setInsightsData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [clearAll, setClearAll] = useState(false);
  const [showButtons, setshowButtons] = useState(false);
  const [tabDescriptions, setTabDescriptions] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const apiGETDataUrl = "api/AdminInsights";
  const apiEditUrl = "api/AdminInsights/Edit";

  const {getApplicationDetail, loading, error } = useGetApplicationData();
  const dispatch = useDispatch();
  
  useEffect(() => {
    const cachedData = sessionStorage.getItem("userDataCache"); // Check session storage for cached data

    if (cachedData) {
      // If data exists in session storage, use it
      const data = JSON.parse(cachedData);
      setSectorData(data);
      setSector(data.sectors[0].sectorId);    
      setIsLoading(false);
    } else {
      // If no cached data, make the API call
      setIsLoading(true);
      if(!getApplicationDetail || Object.keys(getApplicationDetail).length === 0) {
                dispatch(getApplicationData());
        }
                if (
                  getApplicationDetail &&
                  Object.keys(getApplicationDetail).length > 0
                ) {
                  setIsLoading(false);
                   setSectorData(getApplicationDetail);
                   setSector(getApplicationDetail.sectors[0].sectorId);
        
                  // Store fetched data in session storage for future use
                  sessionStorage.setItem(
                    "userDataCache", // Key for user data in session storage
                    JSON.stringify(getApplicationDetail)
                  );
                } else if (error) {
                  setIsLoading(false);
                }
              }
  }, [dispatch, error, getApplicationDetail]);

  useEffect(() => {
    if (sector) {
      getInsightsData();
    }
  }, [sector]);

  const getInsightsData = () => {
    logger.info("Tab-values", value);
    setIsLoading(true);
    apiQueryWithToken
      .post(apiGETDataUrl, {
        sectorID: sector,
        subSectorID: 0,
        countryID: 0,
        regionID: 0,
        ccsid: 0,
        functionID: 0,
        revenueRangeID: 0,
        areaID: 0
      })
      .then((data) => {
        setInsightsData(data.data);
        setIsLoading(false);
        getDescriptions(data.data);
      })
      .catch((error) => {
        setIsLoading(false);
        logger.info(error);
      });
  };
  const handleClearClick = () => {
  const activeTabName = insightsData.insights[value]?.ccsType.toUpperCase();
    let tabWiseDescriptions = tabDescriptions.filter((f) => {
      return f.TabName.toUpperCase() === activeTabName;
    });

    tabWiseDescriptions.map((v) => {
      let key = v.id;
      let flag = "F";
      setCheckboxes1((prevObject) => ({
        ...prevObject,
        [key]: false,
      }));
      const index = changedInsights.findIndex((a) => a.id === key);
      if (index !== -1) {
        changedInsights[index].adminApprovalFlag = flag;
      } else {
        changedInsights.push({ id: key, adminApprovalFlag: flag });
      }
    });

    setChangedInsights(changedInsights);
    setSelectAll(false);
    setClearAll(true);
  };
  const handleSelectAllClick = () => {
    let activeTabName = insightsData.insights[value]?.ccsType.toUpperCase();
    let tabWiseDescriptions = tabDescriptions.filter((f) => {
      return f.TabName.toUpperCase() === activeTabName;
    });

    tabWiseDescriptions.map((v) => {
      let key = v.id;
      let flag = "T";
      setCheckboxes1((prevObject) => ({
        ...prevObject,
        [key]: true,
      }));
      const index = changedInsights.findIndex((a) => a.id === key);
      if (index !== -1) {
        changedInsights[index].adminApprovalFlag = flag;
      } else {
        changedInsights.push({ id: key, adminApprovalFlag: flag });
      }
    });

    setChangedInsights(changedInsights);
    setSelectAll(true);
    setClearAll(false);
  };

  const handleCancelClick = () => {
    if (isSubmitted) {
      changedInsights.map((v) => {
        checkboxes1[v.id] = v.adminApprovalFlag === "T" ? false : true;
      });
    } else {
      if (changedInsights.length > 0) {
        let activeTabName = insightsData.insights[value]?.ccsType.toUpperCase();
        let tabWiseDescriptions = tabDescriptions.filter((f) => {
          return f.TabName.toUpperCase() === activeTabName;
        });
        tabWiseDescriptions.map((v) => {
          checkboxes1[v.id] = v.adminApprovalFlag === "T" ? true : false;
        });
      } else {
        tabDescriptions.map((v) => {
          checkboxes1[v.id] = v.adminApprovalFlag === "T" ? true : false;
        });
      }
    }
    setChangedInsights([]);
    setshowButtons(false);
    setIsInsightEdit(false);
  };

  const handleProceedClick = () => {
    logger.info("changedInsights", changedInsights);
    setShowModal(true);
  };

  const onModalClose = () => {
    handleCancelClick();
    setShowModal(false);
  };

  const handleSectorChange = (event) => {
    setSector(event.target.value);
  };

  const onConfirmClick = () => {
    logger.info("changedInsights onConfirmClick", changedInsights);
    setIsSubmitted(true);

    setIsLoading(true);
    setShowModal(false);
    apiQueryWithToken
      .post(apiEditUrl, {
        requestDatas: changedInsights,
      })
      .then((data) => {
        setshowButtons(false);
        setIsInsightEdit(!isInsightEdit);
        setCheckboxesAfterSubmit();
        getInsightsData();
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        logger.info(error);
      });
  };
  const setCheckboxesAfterSubmit = () => {
    changedInsights?.map((desc) => {
      checkboxes1[desc.id] = desc.adminApprovalFlag === "T" ? true : false;
      setSubmittedInsights([
        ...submittedInsights,
        { id: desc.id, adminApprovalFlag: desc.adminApprovalFlag },
      ]);
    });
    setSubmittedInsights([...submittedInsights, changedInsights]);
    setChangedInsights([]);
  };

  const handleTabChange = (e) => {
    setshowButtons(false);
    let activeTabName = e.target.firstChild?.nodeValue;

    let tabWiseDescriptions = tabDescriptions.filter((f) => {
      return f.TabName === activeTabName;
    });
    if (changedInsights.length > 0) {
      if (isSubmitted) {
        submittedInsights?.map((desc) => {
          checkboxes1[desc.id] = desc.adminApprovalFlag === "T" ? true : false;
        });
        changedInsights.map((v) => {
          checkboxes1[v.id] = v.adminApprovalFlag === "T" ? false : true;
        });
        setChangedInsights([]);
      } else {
        tabWiseDescriptions?.map((desc) => {
          checkboxes1[desc.id] = desc.adminApprovalFlag === "T" ? true : false;
        });
      }
    } else {
      if (isSubmitted) {
        submittedInsights?.map((desc) => {
          checkboxes1[desc.id] = desc.adminApprovalFlag === "T" ? true : false;
        });
      } else {
        tabWiseDescriptions?.map((desc) => {
          checkboxes1[desc.id] = desc.adminApprovalFlag === "T" ? true : false;
        });
      }
    }
    setIsInsightEdit(false);
    setChangedInsights([]);
  };

  const getDescriptions = (apiData) => {
    apiData?.insights.forEach((item) => {
      item.eyServices.forEach((service) => {
        service.kpIs.forEach((kpi) => {
          kpi?.descriptions?.map((v) => {
            //SETTING CHECKBOXES1 array
            let key = v.id;
            setCheckboxes1((prevObject) => ({
              ...prevObject,
              [key]: v.adminApprovalFlag === "T",
            }));

            //Populating All Description data with tabName
            let descItem = {
              TabName: item.ccsType,
              id: v.id,
              adminApprovalFlag: v.adminApprovalFlag,
            };
            let index = tabDescriptions.findIndex((item) => item.id === v.id);
            if (index === -1) {
              tabDescriptions.push(descItem);
            }
          });
        });
      });
    });
    setTabDescriptions(tabDescriptions);
  };

  const handleCheckUncheck = () => {
    let activeTabName = insightsData.insights[value]?.ccsType.toUpperCase();
    let filteredTabData = tabDescriptions.filter((f) => {
      return f.TabName.toUpperCase() === activeTabName;
    });
    let isAllSelected =
      filteredTabData.filter((d) => {
        return d.adminApprovalFlag === "F";
      }).length === 0
        ? true
        : false;
    setSelectAll(isAllSelected);
    setClearAll(!isAllSelected);
  };

  const handleInsightChange = (e, v) => {
    const { name, checked } = e.target;
    setCheckboxes1({ ...checkboxes1, [name]: checked });
    let key = v.id;
    const index = changedInsights.findIndex((a) => a.id === key);
    let flag = e.target.checked ? "T" : "F";
    if (index !== -1) {
      changedInsights[index].adminApprovalFlag = flag;
    } else {
      changedInsights.push({ id: key, adminApprovalFlag: flag });
    }
    setChangedInsights(changedInsights);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const options = ["Edit", "Delete"];

  return (
    <>
      <div className="page-title-wrap">
        <h3>Admin Insights</h3>
      </div>
      <Stepper />
      <div className="admin-insights-wrapper">
        <div className="filter">
          <select value={sector} onChange={handleSectorChange}>
            {sectorData.sectors?.map((item) => {
              return (
                <option key={item.sectorId} value={item.sectorId}>
                  {item.sectorName}
                </option>
              );
            })}
          </select>
        </div>
        <IconButton
          aria-label="more"
          id="edit-insight"
          aria-controls={open ? "edit-insight" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MotifIcon src={moreVerticleIcon} title="more" />
        </IconButton>
        <Menu
          id="edit-insight"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: 200,
              width: "20ch",
            },
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option}
              onClick={() => {
                setIsInsightEdit(!isInsightEdit);
                setshowButtons(!showButtons);
                handleClose();
                handleCheckUncheck();
              }}
              disabled={option === "Delete"}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </div>
      {!sector  ? (
        <MotifProgressLoader show variant="default" />
      ) : insightsData?.insights?.length > 0 ? (
        <div className="insight-inner-tabs">
          <TabContext value={value}>
            <TabList
              arr="checking"
              onChange={(e, newValue) => {
                setValue(newValue);
                handleTabChange(e, newValue);
              }}
              aria-label="lab API tabs example"
              borderBottom={1}
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              {insightsData?.insights?.map((item, index) => (
                <Tab label={item.ccsType} value={index} />
              ))}
              {showButtons && (
                <div className="buttons">
                  <div className="proceed-button">
                    <MotifButton
                      id="btnClear"
                      value="Clear All"
                      onClick={handleClearClick}
                      variant="secondary"
                      size="medium"
                      type="button"
                      disabled={clearAll}
                    >
                      Clear All
                    </MotifButton>
                  </div>
                  <div className="proceed-button">
                    <MotifButton
                      id="btnSelect"
                      value="Select All"
                      onClick={handleSelectAllClick}
                      variant="secondary"
                      size="medium"
                      type="button"
                      disabled={selectAll}
                    >
                      Select All
                    </MotifButton>
                  </div>
                  <div className="proceed-button">
                    <MotifButton
                      onClick={handleCancelClick}
                      variant="secondary"
                      size="medium"
                      type="button"
                      disabled={false}
                    >
                      Cancel
                    </MotifButton>
                  </div>
                  <div className="proceed-button">
                    <MotifButton
                      onClick={handleProceedClick}
                      variant="primary"
                      size="medium"
                      type="button"
                      disabled={false}
                    >
                      Proceed
                    </MotifButton>
                  </div>
                </div>
              )}
            </TabList>
            {insightsData?.insights?.map((item, index) => (
              <TabPanel value={index} sx={{ paddingX: 0 }}>
                <div className="accordion-wrapper">
                  {item?.eyServices?.map((service, index) => (
                    <Accordion
                      key={`outer_${index}`}
                      className="custom-accordion"
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography
                          variant="h6"
                          display="flex"
                          justifyContent="flex-start"
                          fontWeight={600}
                          fontSize={15}
                        >
                          {service?.service}
                          {service?.tags.map((x) => {
                            return (
                              <div className="tags">
                                <div className="tag">{x}</div>
                              </div>
                            );
                          })}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ textAlign: "left" }}>
                        {service?.kpIs?.length > 0 ? (
                          <>
                            {service?.kpIs?.map((kpi, index) => (
                              <Accordion
                                key={`inner_${index}`}
                                className="custom-accordion"
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                >
                                  <Typography
                                    variant="h6"
                                    display="flex"
                                    justifyContent="flex-start"
                                    fontWeight={600}
                                    fontSize={15}
                                  >
                                    {kpi.name}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ textAlign: "left" }}>
                                  <FormGroup>
                                    {kpi?.descriptions?.map((v) => (
                                      <FormControlLabel
                                        required
                                        control={
                                          <MotifCheckbox
                                            id={"textCheckbox_" + v.id}
                                            className="textCheckbox"
                                            name={v.id}
                                            checked={checkboxes1[v.id]}
                                            onClick={(e) => {
                                              handleInsightChange(e, v);
                                            }}
                                            value="checkbox-result-example"
                                          />
                                        }
                                        label={
                                          <SafeHtml html={v.text.replace(/\n/g, "<br>")} style={{ color: "#2E2E38" }} />
                                        }
                                        sx={{
                                          display: "flex",
                                          alignItems: "start",
                                          marginBottom: "15px",
                                        }}
                                        disabled={!isInsightEdit}
                                      />
                                    ))}
                                  </FormGroup>
                                </AccordionDetails>
                              </Accordion>
                            ))}
                          </>
                        ) : (
                          <p>{service?.description ?? ""}</p>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </TabPanel>
            ))}
          </TabContext>
        </div>
      ) : (
        <div className="insight-inner-tabs">No Data Found</div>
      )}
      <ConfirmDialog
        open={showModal}
        onClose={onModalClose}
        onConfirm={onConfirmClick}
      />
    </>
  );
};
